//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getProtocolRateNumber, getApplicantInfo, saveApplicantInfo, seeApplicantInfo } from '@/api/register';
import { getExcelPath, download } from '@/api/baseDataManage';
import { formatMoney } from '@/utils/util';
import pdf from 'vue-pdf';
export default {
  name: 'tApplicationMain',
  components: {
    pdf: pdf
  },
  data: function data() {
    return {
      loading: false,
      fileType: 'pdf',
      pdfsrc: '',
      // 文件地址
      viewVisible: false,
      // 默认false
      rememberMe: false,
      numPages: 0,
      showFlag: true,
      // 投保意向信息
      applicationReqDto: {
        applicationNo: '',
        // 投保意向单号
        applicationStatus: '',
        // 投保意向书状态
        endDate: '',
        // 保险止期(yyyy-MM-dd HH:mm:ss)
        insuredGoods: '保险期间内被保险人自上海港入境的所有冷链食品',
        // 被保险货物
        premium: '',
        // 险费预估（人民币）(BigDecimal)
        rate: '1.05',
        // 保险费率
        startDate: '',
        // 保险起期(yyyy-MM-dd HH:mm:ss)
        submitTime: '',
        // 提交日期
        transPortAmount: '',
        // 年运输额（预估）（人民币）BigDecimal类型
        submitType: '',
        packingMethod: '',
        transportMeans: '',
        insuranceCompanyCode: 'IC0010',
        insuranceCompanyName: '中国人民财产保险股份有限公司',
        companyCode: '31000093',
        companyName: '上海市分公司',
        checked: '0'
      },
      tableData: [{
        insurance: '内陆货物运输险',
        insuranceDuty: '在运输途中由于冷藏机器或隔温设备的损坏所造成保险标的解冻溶化而腐败的损失',
        amount: '进口购买货物金额总额\n即：报关单所载货物单价×货物数量×110%\n\n且，单柜最高保额 200万元，单一客户单航次累计限额不超过400万元',
        deductible: 'RMB1万元或损失金额的15%，以高者为准',
        rate: '0.9‰',
        isInsure: ''
      }, {
        insurance: '内陆货物运输险',
        insuranceDuty: '在进口港或进口地经当地海关或卫生防疫当局检验证明，保险标的的外包装、运输保险标' + '的的集装箱内壁因含有2019新型冠状病毒并且超过了进口国对该病毒的限制要求保险标的被销毁的损失',
        amount: '',
        deductible: '',
        rate: '',
        isInsure: ''
      }, {
        insurance: '食品安全责任险（可选）',
        insuranceDuty: '保险标的因检测出含有2019新型冠状病毒造成消费、食用者人身伤亡或财产损失',
        amount: '200万元/保单累计；\n' + '50万元/每次事故；\n' + '2万元/每人；\n' + '2万元/法律费用\n',
        deductible: '损失金额的10%',
        rate: '0.15‰ \n 投保期初收取最低保费1000元',
        isInsure: ''
      }],
      checked1: true,
      checked: true,
      rateNumber: 0,
      premiumView: '',
      transPortAmountView: '',
      applicationInsuredDtoList: [// --投,被保人对象
        // {
        //   address: '上海',
        //   applicationNo: 'CCIYYMMDD00001', // --投保意向单号
        //   identifyNumber: 110101199812121220,
        //   identifyType: '统一社会信用代码',
        //   identifyTypeCode: '03',
        //   insuredCode: 'string',
        //   insuredEnName: 'string',
        //   insuredName: 'string',
        //   insuredType: '1投保人',
        //   phone: '手机号/电话',
        //   remark: 'string',
        //   serialNo: 1
        // },
        // {
        //   address: '上海', // --联系地址
        //   applicationNo: 'CCIYYMMDD00001', // --投保意向单号
        //   identifyNumber: 110101199812121220, // --证件号
        //   identifyType: '身份证', // --证件类型名称
        //   identifyTypeCode: '03', // --证件类型
        //   insuredCode: 'string', // --关系人代码
        //   insuredEnName: 'string', // --关系人英文名称
        //   insuredName: 'string', // --关系人名称
        //   insuredType: '2被保险人', // --投保人/被保险人类型-"1投保人,2被保险人
        //   phone: '手机号/电话', // --联系电话
        //   remark: 'string', //  --备注
        //   serialNo: 2 // --序号
        // }
      ],
      // 投保人信息
      formData: {
        address: '',
        applicationNo: '',
        // --投保意向单号
        identifyNumber: '',
        identifyType: '统一社会信用代码',
        // 统一社会信用代码
        identifyTypeCode: '10',
        // 03
        insuredCode: '',
        insuredEnName: '',
        insuredName: '',
        linkmanName: '',
        //--联系人
        insuredType: '1',
        phone: '',
        remark: '',
        serialNo: 1
      },
      // 被保险人信息
      listData: {
        address: '',
        // --联系地址
        applicationNo: '',
        // --投保意向单号
        identifyNumber: '',
        // --证件号
        identifyType: '',
        // --证件类型名称
        identifyTypeCode: '',
        // --证件类型
        insuredCode: '',
        // --关系人代码
        insuredEnName: '',
        // --关系人英文名称
        insuredName: '',
        // --关系人名称
        linkmanName: '',
        //--联系人
        insuredType: '2',
        // --投保人/被保险人类型-"1投保人,2被保险人
        phone: '',
        // --联系电话
        remark: '',
        //  --备注
        serialNo: 2 // --序号

      },
      idCard_option: [{
        value: '10',
        label: '统一社会信用代码'
      }, {
        value: '01',
        label: '身份证'
      }, {
        value: '02',
        label: '户口簿'
      }, {
        value: '03',
        label: '护照'
      }, {
        value: '04',
        label: '军官证'
      }, {
        value: '05',
        label: '驾驶执照'
      }, {
        value: '06',
        label: '返乡证'
      }, {
        value: '07',
        label: '复原/退伍证号码'
      }, {
        value: '1',
        label: '组织机构代码证'
      }, {
        value: '3',
        label: '营业执照'
      }, {
        value: '9',
        label: '其他证件'
      }],
      // 证件类型数组
      whole_flag_s: false,
      //
      type: '',
      options: [{
        value: '0',
        label: '暂存成功'
      }, {
        value: '1',
        label: '提交成功'
      }, {
        value: '2',
        label: '已生效'
      }],
      isTrue: false,
      //   formRules:[
      //     phone: [{
      //   required: true,
      //   message: '请输入移动电话',
      //   trigger: 'blur'
      // }, {
      //   pattern: /^1[3|4|5|7|8|6][0-9]{9}$/,
      //   message: '移动电话格式不正确'
      // }],
      //   ]
      formRules: {
        phone: [{
          required: true,
          message: '请输入移动电话',
          trigger: 'blur'
        }, {
          pattern: /^1[3|4|5|7|8|6][0-9]{9}$/,
          message: '移动电话格式不正确'
        }],
        address: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }]
      },
      listRules: {
        phone: [{
          required: true,
          message: '请输入移动电话',
          trigger: 'blur'
        }, {
          pattern: /^1[3|4|5|7|8|6][0-9]{9}$/,
          message: '移动电话格式不正确'
        }],
        address: [{
          required: true,
          message: '请输入地址',
          trigger: 'blur'
        }]
      },
      applicanRules: {
        startDate: [{
          required: true,
          message: '请输入保险起期',
          trigger: 'change'
        }],
        endDate: [{
          required: true,
          message: '请输入保险止期',
          trigger: 'change'
        }],
        transPortAmount: [{
          required: true,
          message: '请输入年运输额(预估)(人民币)',
          trigger: 'change'
        }],
        submitTime: [{
          required: true,
          message: '请输入提交日期',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getProtocolRateNumber().then(function (res) {
      console.log('res--', res);

      if (res.rateNumber) {
        _this.rateNumber = parseInt(res.rateNumber);
      }
    });
  },
  activated: function activated() {
    console.log('1打印传过去的参数--', this.$route.params.type); // this.getTime()

    if (this.$route.params.applicationNo) {
      this.applicationReqDto.applicationNo = this.$route.params.applicationNo;
      this.type = this.$route.params.type;

      if (this.type == 'view') {
        // modify
        this.isTrue = true;
        this.showFlag = false;
        this.rememberMe = true;
      } else {
        this.isTrue = false;
        this.showFlag = true;
      }

      this.getQueryInfo();
    } else {
      this.getInfo();
    }
  },
  created: function created() {
    console.log('打印传过去的参数--', this.$route.params.type); // this.getTime()

    this.getInfo();

    if (this.$route.params.applicationNo) {
      this.applicationReqDto.applicationNo = this.$route.params.applicationNo;
      this.type = this.$route.params.type;

      if (this.type == 'view') {
        // modify
        this.isTrue = true;
        this.showFlag = false;
        this.rememberMe = true;
      } else {
        this.isTrue = false;
        this.showFlag = true;
      }

      this.getQueryInfo();
    }
  },
  methods: {
    setPhone: function setPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 3) + "****" + tel.substring(9);
        return str;
      } else {
        var _str = " ";
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        _str = tel.replace(reg, "$1****$2");
        return _str;
      }
    },
    setListPhone: function setListPhone(tel) {
      if (tel.indexOf("-") != -1) {
        tel = " " + tel;
        var str = " ";
        str = tel.substring(0, 3) + "****" + tel.substring(9);
        return str;
      } else {
        var _str2 = " ";
        var reg = /(\d{3})\d{4}(\d{4})/; //正则表达式

        _str2 = tel.replace(reg, "$1****$2");
        return _str2;
      }
    },
    setApplicationAddress: function setApplicationAddress(tel) {
      // 投保人 联系人地址
      if (tel.length > 4) {
        tel = " " + tel;
        var str = " ";
        str = tel.slice(0, -4) + "****";
        return str;
      } else {
        tel = " " + tel;
        var _str3 = " ";
        _str3 = tel.slice(0, 0) + "****";
        return _str3;
      }
    },
    setListAddress: function setListAddress(tel) {
      //被保人 联系人地址
      if (tel.length > 4) {
        tel = " " + tel;
        var str = " ";
        str = tel.slice(0, -4) + "****";
        return str;
      } else {
        tel = " " + tel;
        var _str4 = " ";
        _str4 = tel.slice(0, 0) + "****";
        return _str4;
      }
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (columnIndex !== 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    changeSelected: function changeSelected(val) {
      console.log('是否选中', val);

      if (val) {
        this.rememberMe = true;
      } else {
        this.rememberMe = false;
      }
    },
    closeDialog: function closeDialog() {
      this.viewVisible = false;
    },
    changeBLinkmanName: function changeBLinkmanName() {
      if (!this.listData.linkmanName) {
        this.$message({
          message: '请输入联系人',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeName: function changeName() {
      if (!this.listData.insuredName) {
        this.$message({
          message: '请输入被保险人名称',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeAdress: function changeAdress(e) {
      var value = e.target.value;
      console.log('地址value---', value);

      if (!value) {
        this.$message({
          message: '请输入被保险人地址',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeIdNumber: function changeIdNumber(e) {
      console.log('---------identifyTypeCode:' + this.listData.identifyTypeCode);
      var value = e.target.value;
      console.log('证件号value---', value);
      /*
      const regExp = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g
      if (!regExp.test(value)) {
        this.$message({
          message: '请输入正确的统一社会信用代码',
          type: 'error',
          duration: 3000
        })
        return false
      }
      */

      var isT = false;

      switch (this.listData.identifyTypeCode) {
        case '01':
          var exp = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

          if (!exp.test(value)) {
            isT = true;
            this.$message({
              message: '身份证号输入不正确',
              type: 'error',
              duration: 3000
            });
          }

          break;

        case '02':
          var exp2 = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

          if (!exp2.test(value)) {
            isT = true;
            this.$message({
              message: '户口簿证件号输入不正确',
              type: 'error',
              duration: 3000
            });
          }

          break;

        case '03':
          var exp3 = /^([a-zA-z]|[0-9]){5,17}$/;

          if (!exp3.test(value)) {
            isT = true;
            this.$message({
              message: '护照证件号输入不正确',
              type: 'error',
              duration: 3000
            });
          }

          break;

        case '04':
          var exp4 = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;

          if (!exp4.test(value)) {
            isT = true;
            this.$message({
              message: '军官证证件号输入不正确',
              type: 'error',
              duration: 3000
            });
          }

          break;

        case '05':
          var exp5 = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9X]$/;

          if (!exp5.test(value)) {
            isT = true;
            this.$message({
              message: '驾驶执照证件号输入不正确',
              type: 'error',
              duration: 3000
            });
          }

          break;

        case '06':
          var exp6 = this.listData.identifyNumber;
          console.log('是否输入了值', exp6);

          if (!exp6) {
            isT = true;
            this.$message({
              message: '请输入返乡证',
              type: 'error',
              duration: 3000
            });
          }

          break;

        case '07':
          var exp7 = this.listData.identifyNumber;

          if (!exp7) {
            isT = true;
            this.$message({
              message: '请输入复原或退伍号码',
              type: 'error',
              duration: 3000
            });
          }

        case '10':
          var exp10 = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;

          if (!exp10.test(value)) {
            isT = true;
            this.$message({
              message: '请输入正确的统一社会信用代码',
              type: 'error',
              duration: 3000
            });
          }

        default:
          isT = true;
      }

      if (isT) {
        return false;
      }
    },
    changeBPhone: function changeBPhone(e) {
      console.log('e------', e.target.value);
      var value = e.target.value;
      var regMobilePhone = /^1[3456789]\d{9}$/;
      var regTelephone = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/; // var regularPhone=/^(((\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14})|(1[34578]\d{9}))$/;

      if (!(regMobilePhone.test(value) || regTelephone.test(value))) {
        this.$message({
          message: '请输入正确的联系电话',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeTAddress: function changeTAddress() {
      console.log('22222');

      if (!this.formData.address) {
        this.$message({
          message: '请输入投保人联系地址',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeLinkmanName: function changeLinkmanName() {
      console.log('22222');

      if (!this.formData.linkmanName) {
        this.$message({
          message: '请输入联系人',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeTPhone: function changeTPhone(e) {
      console.log('e------', e.target.value);
      var value = e.target.value;
      var regMobilePhone = /^1[3456789]\d{9}$/;
      var regTelephone = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/; // var regularPhone=/^(((\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14})|(1[34578]\d{9}))$/;

      if (!(regMobilePhone.test(value) || regTelephone.test(value))) {
        this.$message({
          message: '请输入正确的联系电话',
          type: 'error',
          duration: 3000
        });
        return false;
      }
    },
    changeStartDate: function changeStartDate(date) {
      console.log('选中的date', date);
      var d = new Date(date);
      d.setDate(d.getDate());
      var currentDate = new Date();
      console.log('当前日期1', currentDate);
      console.log('当前日期时间戳', currentDate.setDate(currentDate.getDate()));
      console.log('选中的日期时间戳d.setDate(d.getDate())', d.setDate(d.getDate()));

      if (d.setDate(d.getDate()) < currentDate.setDate(currentDate.getDate())) {
        this.$message({
          message: '保险起期应大于当前日期！',
          type: 'error',
          duration: 3000
        });
        this.applicationReqDto.startDate = '';
        return false;
      } else {
        var endDate = new Date(new Date(date).setFullYear(d.getFullYear() + 1));
        console.log('endDate111', endDate);
        var timestamp = endDate.setDate(endDate.getDate());
        timestamp = timestamp / 1000;
        console.log('timestamp1', timestamp);
        console.log('timestamp2', timestamp);
        timestamp -= 86400; // 加一天

        console.log('timestamp3', timestamp);
        timestamp = timestamp * 1000;
        console.log('timestamp4', timestamp);
        var da = new Date(timestamp);
        var year = da.getFullYear();
        var month = da.getMonth() + 1;
        var date = da.getDate();
        var createDate = [year, month, date].join('-');
        console.log('createDate', createDate);
        this.applicationReqDto.endDate = createDate;
        console.log('起期this.applicationReqDto.startDate--', this.applicationReqDto.startDate);
        console.log('止期this.applicationReqDto.endDate--', this.applicationReqDto.endDate);
      }
    },
    // 查看/修改
    getQueryInfo: function getQueryInfo() {
      var _this2 = this;

      seeApplicantInfo({
        applicationNo: this.$route.params.applicationNo
      }).then(function (res) {
        console.log('查看、修改res--', res);
        _this2.formData = res.applicationInsuredDtoList[0];
        _this2.listData = res.applicationInsuredDtoList[1];
        _this2.applicationReqDto.startDate = res.startDate;
        _this2.applicationReqDto.applicationStatus = res.applicationStatus;
        _this2.applicationReqDto.endDate = res.endDate;
        _this2.applicationReqDto.insuredGoods = res.insuredGoods;
        _this2.applicationReqDto.premium = res.premium;
        _this2.applicationReqDto.rate = res.rate;
        _this2.applicationReqDto.startDate = res.startDate;
        _this2.applicationReqDto.submitTime = res.submitTime;
        _this2.applicationReqDto.transPortAmount = res.transPortAmount;
        _this2.applicationReqDto.submitType = res.submitType;
        _this2.applicationReqDto.packingMethod = res.packingMethod;
        _this2.applicationReqDto.transportMeans = res.transportMeans;
        _this2.applicationReqDto.insuranceCompanyCode = res.insuranceCompanyCode;
        _this2.applicationReqDto.insuranceCompanyName = res.insuranceCompanyName;
        _this2.applicationReqDto.companyName = res.companyName;
        _this2.applicationReqDto.companyCode = res.companyCode;
        _this2.applicationReqDto.checked = res.checked;
        _this2.checked = _this2.applicationReqDto.checked == '1';

        _this2.qfhView();

        if (_this2.type == 'view') {
          //投保人 联系人电话脱敏
          if (_this2.formData.phone != null && _this2.formData.phone != '') {
            _this2.formData.phone = _this2.setPhone(_this2.formData.phone);
          } //被保险人 联系人电话脱敏


          if (_this2.listData.phone != null && _this2.listData.phone != '') {
            _this2.listData.phone = _this2.setListPhone(_this2.listData.phone);
          } //投保人 联系地址脱敏


          if (_this2.formData.address != null && _this2.formData.address != '') {
            _this2.formData.address = _this2.setApplicationAddress(_this2.formData.address);
          } //被保人 联系地址脱敏


          if (_this2.listData.address != null && _this2.listData.address != '') {
            _this2.listData.address = _this2.setListAddress(_this2.listData.address);
          }
        }
      });
    },
    // totalYeare
    totalYear: function totalYear(e) {
      console.log('输入额', e.target.value);

      if (!e.target.value) {
        this.$message({
          message: '请输入年运输额(预估)(元)',
          type: 'error',
          duration: 3000
        });
        return false;
      } else {
        var reg = new RegExp(',', 'g');
        var num = parseFloat(e.target.value.replace(reg, ''));
        console.log('录入值：', num);
        var exp = /[0-9.]/g;

        if (!exp.test(num)) {
          this.transPortAmountView = '';
          return false;
        }

        if (num < 0) {
          this.$message({
            message: '年运输额(预估)(元)必须大于0',
            type: 'error',
            duration: 3000
          });
          return false;
        }

        var number = parseFloat(num) * 0.00105;

        if (this.checked) {
          var number1 = parseFloat(num) * 0.0009;
          var number2 = parseFloat(num) * 0.00015;

          if (number2 <= this.rateNumber) {
            number = number1 + this.rateNumber;
          }
        } else {
          number = parseFloat(num) * 0.0009;
        }

        if (parseInt(number) == number) {
          this.applicationReqDto.premium = number;
        } else {
          this.applicationReqDto.premium = number.toFixed(2);
        }

        this.applicationReqDto.transPortAmount = num;
        this.qfhView();
      }
    },
    qfhView: function qfhView() {
      if (this.applicationReqDto.premium) {
        this.premiumView = formatMoney(this.applicationReqDto.premium, 2);
      }

      if (this.applicationReqDto.transPortAmount) {
        this.transPortAmountView = formatMoney(this.applicationReqDto.transPortAmount, 2);
      }

      console.log(this.premiumView + "--------------====----------" + this.transPortAmountView);
    },
    getInfo: function getInfo() {
      var _this3 = this;

      getApplicantInfo().then(function (res) {
        console.log('res--', res);
        _this3.formData.insuredName = res.userName;
        _this3.formData.identifyNumber = res.orgCode;
        _this3.formData.identifyTypeCode = '10';
        _this3.formData.identifyType = '统一社会信用代码';
        _this3.formData.address = res.address;
        _this3.formData.linkmanName = res.linkmanName;
        _this3.formData.phone = res.phone;

        if (_this3.type == 'view') {
          if (_this3.formData.phone != null && _this3.formData.phone != '') {
            //投保人联系电话 脱敏
            _this3.formData.phone = _this3.setPhone(_this3.formData.phone);
          }

          if (_this3.formData.address != null && _this3.formData.address != '') {
            //投保人联系地址 脱敏
            _this3.formData.address = _this3.setApplicationAddress(_this3.formData.address);
          }
        }
      });
    },
    // 投保人姓名
    // applicantName_ch() {
    //
    // },
    // 证件类型
    // identifyType_ch1() {
    //
    // },
    // 证件号
    // identifyNumber_ch1() {
    //
    // },
    // 联系电话
    // linkmanPhone_ch() {
    //
    // },
    // 联系地址
    // linkmanAddress_ch() {
    //
    // },
    open_insured: function open_insured() {
      console.log('触发---11');
      console.log(this.showFlag);

      if (this.formData.insuredName && this.formData.phone) {
        this.listData.insuredName = this.formData.insuredName;
        this.listData.identifyNumber = this.formData.identifyNumber;
        this.listData.identifyTypeCode = this.formData.identifyTypeCode;
        this.listData.identifyType = this.formData.identifyType;
        this.listData.phone = this.formData.phone;
        this.listData.address = this.formData.address;
        this.listData.linkmanName = this.formData.linkmanName;
      }
    },
    //  点击展示投保须知内容   // 预览
    showWords: function showWords() {
      // let url = item.AttachmentPath + "/anli?id=" + item.MessageAttachmentId
      console.log("checked:" + this.checked);
      var type;

      if (this.checked) {
        type = "coldFood";
      } else {
        type = "coldNoFood";
      }

      getExcelPath({
        fileDownloadType: type
      }).then(function (res) {
        console.log('预览res', res); // this.viewVisible = true
        // const urls = res.fileSrc
        // this.pdfsrc = pdf.createLoadingTask(urls)
        // console.log('this.pdfsrc =', this.pdfsrc)
        // 获取下载文件

        download({
          fileSrc: res.fileSrc
        }).then(function (res2) {
          var blob = new Blob([res2], {
            type: 'application/vnd.ms-pdf'
          }); // 兼容ie

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, '《进口食品安全综合保险》投保须知及重要事项说明.pdf');
          } else {
            var url = window.URL.createObjectURL(blob);
            var link = document.createElement('a'); // 创建a标签

            link.href = url;
            link.download = '《进口食品安全综合保险》投保须知及重要事项说明.pdf'; // 重命名文件

            link.click();
            window.URL.revokeObjectURL(url); // 释放内存
          }
        }); // this.pdfsrc.then(pdf => {
        //   console.log('pdf*******', pdf)
        //   this.numPages = pdf.numPages
        //   console.log('this.numPages',this.numPages)
        // }).catch((res) => {
        //   console.log('catch-res', res)
        // })
      }); // this.viewVisible = true
      // // 以下代码高能
    },
    // 获取当前日期的年月日时分秒
    getTime: function getTime() {
      var date = new Date();
      var seperator1 = '-';
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var hour = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      var strDate = date.getDate();

      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }

      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
      }

      var currentdate = year + seperator1 + month + seperator1 + strDate + '  ' + hour + ':' + minutes + ':' + seconds;
      console.log('currentdate---', currentdate);
      this.applicationReqDto.submitTime = currentdate;
    },
    modifyRate: function modifyRate() {
      console.log('----------------------------------------' + this.checked);
      var transPortAmount = this.applicationReqDto.transPortAmount;

      if (transPortAmount) {
        var number = parseFloat(transPortAmount) * 0.00105;

        if (this.checked) {
          this.applicationReqDto.rate = '1.05';
          var number1 = parseFloat(transPortAmount) * 0.0009;
          var number2 = parseFloat(transPortAmount) * 0.00015;

          if (number2 <= 1000) {
            number = number1 + 1000;
          }
        } else {
          this.applicationReqDto.rate = '0.9';
          number = parseFloat(transPortAmount) * 0.0009;
        }

        if (parseInt(number) == number) {
          this.applicationReqDto.premium = number;
        } else {
          this.applicationReqDto.premium = number.toFixed(2);
        }

        this.qfhView();
      } else {
        if (this.checked) {
          this.applicationReqDto.rate = '1.05';
        } else {
          this.applicationReqDto.rate = '0.9';
        }
      }
    },
    // 点击暂存/提交
    saveButton: function saveButton(id) {
      var _this4 = this;

      console.log('id===', id);
      this.getTime();
      console.log('打印提交时的参数' + this.formData.identifyTypeCode + ' ' + this.listData.identifyTypeCode);

      if (this.formData.identifyType) {
        this.idCard_option.forEach(function (item) {
          if (item.label == _this4.formData.identifyType) {
            _this4.formData.identifyTypeCode = item.value;
          }
        });
      }

      if (this.listData.identifyType) {
        this.idCard_option.forEach(function (item) {
          if (item.value == _this4.listData.identifyTypeCode) {
            _this4.listData.identifyType = item.label;
          }
        });
      }

      console.log('打印提交时的参数', this.applicationInsuredDtoList);

      if (id == '0') {
        this.applicationReqDto.submitType = '0';
        this.applicationInsuredDtoList.push(this.formData);
        this.applicationInsuredDtoList.push(this.listData);
        saveApplicantInfo({
          applicationInsuredDtoList: this.applicationInsuredDtoList,
          applicationNo: this.applicationReqDto.applicationNo,
          applicationStatus: this.applicationReqDto.applicationStatus,
          endDate: this.applicationReqDto.endDate,
          insuredGoods: this.applicationReqDto.insuredGoods,
          premium: this.applicationReqDto.premium,
          rate: this.applicationReqDto.rate,
          startDate: this.applicationReqDto.startDate,
          submitTime: this.applicationReqDto.submitTime,
          transPortAmount: this.applicationReqDto.transPortAmount,
          submitType: this.applicationReqDto.submitType,
          packingMethod: this.applicationReqDto.packingMethod,
          transportMeans: this.applicationReqDto.transportMeans,
          insuranceCompanyCode: this.applicationReqDto.insuranceCompanyCode,
          insuranceCompanyName: this.applicationReqDto.insuranceCompanyName,
          companyCode: this.applicationReqDto.companyCode,
          companyName: this.applicationReqDto.companyName,
          checked: this.checked ? 1 : 0
        }).then(function (res) {
          console.log('打印保存---res', res);

          if (res.rtnCode = '0000') {
            _this4.applicationReqDto.applicationNo = res.applicationNo;
            _this4.applicationReqDto.applicationStatus = res.applicationStatus;

            _this4.$message({
              message: res.returnMsg,
              type: 'success',
              duration: 5000
            }); // this.$forceUpdate()


            _this4.applicationInsuredDtoList = [];

            if (id == '0') {
              _this4.applicationInsuredDtoList = [];
            } else {
              _this4.$router.push({
                name: 'policyIntentManagement'
              });
            }
          } else if (res.rtnCode = '9999') {
            _this4.$message({
              message: res.returnMsg,
              type: 'error'
            });

            return false;
          }
        });
      } else {
        if (!this.formData.phone) {
          this.$message({
            message: '请输入投保人联系电话！',
            duration: 3000
          });
          return false;
        }

        if (!this.formData.address) {
          this.$message({
            message: '请输入投保人联系地址！',
            duration: 3000
          });
          return false;
        }

        if (!this.listData.identifyNumber) {
          this.$message({
            message: '请输入被保人证件号！',
            duration: 3000
          });
          return false;
        }

        if (!this.listData.insuredName) {
          this.$message({
            message: '请输入被保人名称！',
            duration: 3000
          });
          return false;
        }

        if (!this.listData.phone) {
          this.$message({
            message: '请输入被保人联系电话！',
            duration: 3000
          });
          return false;
        }

        if (!this.listData.address) {
          this.$message({
            message: '请输入被保人联系地址！',
            duration: 3000
          });
          return false;
        }

        if (!this.applicationReqDto.startDate) {
          this.$message({
            message: '请选择保险起期！',
            duration: 3000
          });
          return false;
        }

        if (!this.applicationReqDto.endDate) {
          this.$message({
            message: '请选择保险止期！',
            duration: 3000
          });
          return false;
        }

        if (!this.applicationReqDto.transPortAmount) {
          this.$message({
            message: '请输入年运输额(预估)(人民币)！',
            duration: 3000
          });
          return false;
        }
        /* if (!this.applicationReqDto.packingMethod) {
           this.$message({
             message: '请输入包装方式！',
             duration: 3000
           })
           return false
         }
         if (!this.applicationReqDto.transportMeans) {
           this.$message({
             message: '请输入运输工具！',
             duration: 3000
           })
           return false
         }*/


        if (!this.applicationReqDto.submitTime) {
          this.$message({
            message: '请选择提交日期!',
            duration: 3000
          });
          return false;
        }

        if (!this.rememberMe) {
          this.$message({
            message: '请详细阅读《进口食品安全综合保险》投保须知及重要事项说明并勾选',
            type: 'error',
            duration: 5000
          });
          return false;
        }

        this.applicationReqDto.submitType = '1';
        this.applicationInsuredDtoList.push(this.formData);
        this.applicationInsuredDtoList.push(this.listData);
        this.loading = true;
        saveApplicantInfo({
          applicationInsuredDtoList: this.applicationInsuredDtoList,
          applicationNo: this.applicationReqDto.applicationNo,
          applicationStatus: this.applicationReqDto.applicationStatus,
          endDate: this.applicationReqDto.endDate,
          insuredGoods: this.applicationReqDto.insuredGoods,
          premium: this.applicationReqDto.premium,
          rate: this.applicationReqDto.rate,
          startDate: this.applicationReqDto.startDate,
          submitTime: this.applicationReqDto.submitTime,
          transPortAmount: this.applicationReqDto.transPortAmount,
          submitType: this.applicationReqDto.submitType,
          insuranceCompanyCode: this.applicationReqDto.insuranceCompanyCode,
          insuranceCompanyName: this.applicationReqDto.insuranceCompanyName,
          companyCode: this.applicationReqDto.companyCode,
          companyName: this.applicationReqDto.companyName,
          packingMethod: this.applicationReqDto.packingMethod,
          transportMeans: this.applicationReqDto.transportMeans,
          checked: this.checked ? 1 : 0
        }).then(function (res) {
          console.log('打印保存---res', res);

          if (res.rtnCode = '0000') {
            _this4.applicationReqDto.applicationNo = res.applicationNo;
            _this4.applicationReqDto.applicationStatus = res.applicationStatus;
            _this4.loading = false;

            _this4.$message({
              message: res.returnMsg,
              type: 'success',
              duration: 3000
            }); // this.$forceUpdate()


            _this4.applicationInsuredDtoList = []; // 关闭导航栏

            _this4.$store.dispatch('delVisitedViews', _this4.$route);

            _this4.$router.push({
              path: '/importedColdChain/policyIntentManagement'
            }); // this.$router.go('-1')
            // if (id == '0') {
            //   this.applicationInsuredDtoList = []
            // } else {
            //
            // }

          } else if (res.rtnCode = '9999') {
            _this4.applicationInsuredDtoList = [];

            _this4.$message({
              message: res.returnMsg,
              type: 'error'
            });

            return false;
          }
        });
      }
    },
    //  点击取消
    cancelBtn: function cancelBtn() {
      // this.$router.push({ path: '/' })
      this.$router.go('-1'); // 关闭导航栏

      this.$store.dispatch('delVisitedViews', this.$route);
    },
    renderHeader: function renderHeader(h, para) {
      return h('div', {
        attrs: {
          class: 'cell'
        },
        domProps: {
          innerHTML: '费率</br>（不含手续费费率）'
        }
      });
    }
  }
};